<template>
    <div id="fusion_conversations_container" class="">
      <!-- Static design prototype: the conversation cards below render sample fixture data
           (names, message snippets, timestamps) only — that text is intentionally not localized. -->
      <ul class="messaging_nav flex flex-wrap list-none pl-0 justify-start items-center px-2 my-3 pb-3">
        <li class="mx-2">
          <a class="block py-2 px-4 rounded text-sm" href="#" :class="{'active':active_tab === 'All'}" @click.prevent="setActiveTab('All')"><i class="ri-group-2-line" /> {{ $t('conversations.tabs.all') }}</a>
        </li>
        |
        <li class="mx-2">
          <a class="block py-2 px-4 rounded text-sm" href="#" :class="{'active':active_tab === 'Chat'}" @click.prevent="setActiveTab('Chat')"><i class="ri-chat-3-line" /> {{ $t('conversations.tabs.chat') }}</a>
        </li>
        <li class="mx-2">
          <a class="block py-2 px-4 rounded text-sm" href="#" :class="{'active':active_tab === 'Text'}" @click.prevent="setActiveTab('Text')"><i class="ri-hashtag" /> {{ $t('conversations.tabs.text') }}</a>
        </li>
        <li class="mx-2">
          <a class="block py-2 px-4 rounded text-sm" href="#" :class="{'active':active_tab === 'CallLog'}" @click.prevent="setActiveTab('CallLog')"><i class="ri-team-line" /> {{ $t('conversations.tabs.callLog') }}</a>
        </li>
        <li class="mx-2">
          <a class="block py-2 px-4 rounded text-sm" href="#" :class="{'active':active_tab === 'Mentions'}" @click.prevent="setActiveTab('Mentions')"><i class="ri-team-line" /> {{ $t('conversations.tabs.mentions') }}</a>
        </li>
        <li class="mx-2">
          <a class="block py-2 px-4 rounded text-sm" href="#" :class="{'active':active_tab === 'Starred'}" @click.prevent="setActiveTab('Starred')"><i class="ri-team-line" /> {{ $t('conversations.tabs.starred') }}</a>
        </li>
        <li class="mx-2">
          <a class="block py-2 px-4 rounded text-sm" href="#" :class="{'active':active_tab === 'Drafts'}" @click.prevent="setActiveTab('Drafts')"><i class="ri-team-line" /> {{ $t('conversations.tabs.drafts') }}</a>
        </li>
      </ul>
      <div :id="`${active_tab}Component_container`" class="w-full h-full">
        <div class="header-for-main-screens-parent">
          
          <div class="conversation-card-parent">
            <div class="conversation-card">
              <div class="conversations-avatar">
                <div class="avatar">
                  <div class="initials">🐶</div>
                </div>
                <i class="message_card_avatar_icon ri-mail-line ri-xs text-text-subtle" />
              </div>
              <div class="lil-mouse-parent">
                <div class="lil-mouse">Anonymous Dog</div>
                <div class="summer-sale-event-container">
                  <span>Summer Sale Event </span>
                  <span class="im-interested-in">– I’m interested in either model</span>
                </div>
              </div>
              <div class="lil-mouse-wrapper">
                <div class="lil-mouse1">Now</div>
              </div>
            </div>
            <div class="conversation-card">
              <div class="conversations-avatar">
                <div class="avatar1">
                  <div class="initials">🐠</div>
                </div>
                <div class="conversation-avatar-icon1">
                  <img class="vector-stroke-icon" alt="" src="@images/fusion_chat_icon.svg">
                </div>
              </div>
              <div class="lil-mouse-parent">
                <div class="lil-mouse">Friendly Fish</div>
                <div class="summer-sale-event-container">I’m interested in either model, I think.</div>
              </div>
              <div class="lil-mouse-wrapper">
                <div class="lil-mouse3">3 min ago</div>
              </div>
            </div>
            <div class="conversation-card">
              <div class="conversations-avatar">
                <div class="avatar2">
                  <div class="initials">HS</div>
                </div>
                <div class="conversation-avatar-icon1">
                  <img class="vector-stroke-icon" alt="" src="@images/fusion_chat_icon.svg">
                </div>
              </div>
              <div class="lil-mouse-parent">
                <div class="lil-mouse">Haylie Saris</div>
                <div class="olivia-what-do-container">I’m interested in either model, I think.</div>
              </div>
              <div class="lil-mouse-wrapper">
                <div class="lil-mouse5">3:45 PM</div>
              </div>
            </div>
            <div class="conversation-card3">
              <div class="conversations-avatar3">
                <div class="avatar3">
                  <div class="initials">KS</div>
                </div>
                <i class="message_card_avatar_icon ri-chat-smile-2-line ri-xs text-text-subtle" />
              </div>
              <div class="lil-mouse-parent1">
                <div class="lil-mouse">Kianna Schleifer</div>
                <div class="olivia-what-do-container">I’m interested in either model, I think.</div>
              </div>
              <div class="lil-mouse-wrapper1">
                <div class="lil-mouse7">3:15 PM</div>
              </div>
              <img class="avatar-mobile-icon" alt="" src="@images/avatar.png">
            
            </div>
            <div class="conversation-card3">
              <div class="conversations-avatar3">
                <div class="avatar">
                  <div class="initials">🐶</div>
                </div>
                <i class="message_card_avatar_icon ri-chat-smile-2-line ri-xs text-text-subtle" />
              </div>
              <div class="lil-mouse-parent1">
                <div class="lil-mouse">Anonymous Dog</div>
                <div class="olivia-what-do-container">I’m interested in either model, I think.</div>
              </div>
              <div class="lil-mouse-wrapper1">
                <div class="lil-mouse5">[2:32 PM]</div>
              </div>
              <img class="auto-layout-horizontal" alt="" src="@images/reply_icon.svg" />
            
            </div>
            <div class="conversation-card5">
              <div class="conversations-avatar">
                <img class="avatar-icon" alt="" src="@images/avatar.png">
                
                <div class="conversation-avatar-icon1">
                  <img class="inbound-icon" alt="" src="@images/fusion_call_icon.svg">
                </div>
              </div>
              <div class="lil-mouse-parent3">
                <div class="lil-mouse">Bella Carter</div>
                <div class="mins">32:21 mins</div>
              </div>
              <div class="lil-mouse-wrapper">
                <div class="lil-mouse7">2:15 PM</div>
              </div>
            </div>
            <div class="conversation-card">
              <div class="conversations-avatar">
                <div class="avatar">
                  <div class="initials">🐶</div>
                </div>
                <i class="message_card_avatar_icon ri-chat-smile-2-line ri-xs text-text-subtle" />
              </div>
              <div class="lil-mouse-parent4">
                <div class="lil-mouse">Anonymous Dog</div>
                <div class="olivia-what-do-container">
                  <span class="olivia">@Olivia</span>
                  <span class="what-do-you"> What do you think?</span>
                </div>
              </div>
              <div class="lil-mouse-wrapper">
                <div class="lil-mouse7">2:14 PM</div>
              </div>
            </div>
            <div class="conversation-card">
              <div class="conversations-avatar">
                <div class="avatar">
                  <div class="initials">🐶</div>
                </div>
                <i class="message_card_avatar_icon ri-mail-line ri-xs text-text-subtle" />
              </div>
              <div class="frame-parent">
                <div class="lil-mouse-parent5">
                  <div class="lil-mouse">Anonymous Dog</div>
                  <div class="lil-mouse15">Draft</div>
                </div>
                <div class="summer-sale-event-container1">
                  <span>Summer Sale Event </span>
                  <span class="im-interested-in">– I’m interested in either model</span>
                </div>
              </div>
              <div class="lil-mouse-wrapper">
                <div class="lil-mouse3">Yesterday</div>
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
</template>

<style scoped lang="scss">
  .messaging_nav {
    //display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    //overflow-y: hidden;
    white-space: nowrap;
    
    li {
      background: var(--background-layer-02);
      border-radius: 4px;
      
      a {
        padding: 4px 7px;
        color: var(--text-default);
      }
      
      a.active {
        border-radius: 4px;
        border: 1px solid var(--border-default);
        background: var(--background-layer-01);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
      }
    }
  }
  
  .message_card_avatar_icon {
    position: absolute;
    top: 22px;
    left: 22px;
    border-radius: 40px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    background: var(--background-layer-01);
    padding-left: 1px;
  }
  .initials {
    position: relative;
    line-height: 22px;
    font-weight: 600;
  }
  .avatar {
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 100px;
    background-color: #ffe3bf;
    width: 32px;
    height: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .rimail-line-icon {
    position: absolute;
    top: calc(50% - 6px);
    left: calc(50% - 6px);
    width: 12px;
    height: 12px;
  }
  .conversation-avatar-icon {
    position: absolute;
    top: 22px;
    left: 22px;
    border-radius: 40px;
    background-color: #fff; // avatar icon badge bg
    width: 12px;
    height: 12px;
  }
  .conversations-avatar {
    width: 32px;
    position: relative;
    height: 32px;
  }
  .lil-mouse {
    position: relative;
    letter-spacing: 0.16px;
    line-height: 18px;
    font-weight: 500;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), var(--gray-70);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .im-interested-in {
    color: rgba(0, 0, 0, 0.6);
  }
  .summer-sale-event-container {
    align-self: stretch;
    position: relative;
    font-size: 13px;
    letter-spacing: 0.1px;
    line-height: 135%;
    font-weight: 600;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 18px;
    flex-shrink: 0;
  }
  .lil-mouse-parent {
    flex: 1;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
    font-size: 14px;
    color: var(--text-default);
  }
  .lil-mouse1 {
    position: absolute;
    top: 0px;
    left: 0px;
    letter-spacing: 0.16px;
    line-height: 16px;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), var(--gray-60);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .lil-mouse-wrapper {
    width: 27px;
    position: relative;
    height: 16px;
    text-align: right;
    font-size: 12px;
  }
  .conversation-card {
    align-self: stretch;
    background-color: var(--background-layer-01);
    border-b: 1px solid var(--border-separator);
    box-sizing: border-box;
    height: 72px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 16px 12px;
    gap: 12px;
  }
  .avatar1 {
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 100px;
    background-color: #d3edff;
    width: 32px;
    height: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .vector-stroke-icon {
    position: absolute;
    top: calc(50% - 5.25px);
    left: calc(50% - 4.5px);
    width: 13px;
    height: 14px;
  }
  .conversation-avatar-icon1 {
    position: absolute;
    top: 22px;
    left: 22px;
    border-radius: 40px;
    width: 12px;
    height: 12px;
  }
  .lil-mouse3 {
    position: absolute;
    top: 0px;
    left: -31px;
    letter-spacing: 0.16px;
    line-height: 16px;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), var(--gray-60);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .avatar2 {
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 100px;
    background-color: #95c942;
    width: 32px;
    height: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .lil-mouse5 {
    position: absolute;
    top: 0px;
    left: -22px;
    letter-spacing: 0.16px;
    line-height: 16px;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), var(--gray-60);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .avatar3 {
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 100px;
    background-color: #636ae9;
    width: 32px;
    height: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .richat-smile-2-line-icon {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 12px;
    height: 12px;
  }
  .conversations-avatar3 {
    width: 32px;
    position: relative;
    height: 32px;
    z-index: 0;
  }
  .lil-mouse-parent1 {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
    z-index: 1;
    font-size: 14px;
    color: var(--text-default);
  }
  .lil-mouse7 {
    position: absolute;
    top: 0px;
    left: -20px;
    letter-spacing: 0.16px;
    line-height: 16px;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), var(--gray-60);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .lil-mouse-wrapper1 {
    width: 27px;
    position: relative;
    height: 16px;
    z-index: 2;
    text-align: right;
    font-size: 12px;
  }
  .avatar-mobile-icon {
    width: 20px;
    margin: 0 !important;
    position: absolute;
    bottom: 12px;
    right: 12px;
    border-radius: 100px;
    height: 20px;
    object-fit: cover;
    z-index: 3;
  }
  .conversation-card3 {
    align-self: stretch;
    background-color: var(--background-layer-01);
    border-b: 1px solid var(--border-separator);
    box-sizing: border-box;
    height: 72px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 16px 12px;
    position: relative;
    gap: 12px;
  }
  .auto-layout-horizontal {
    width: 20px;
    margin: 0 !important;
    position: absolute;
    bottom: 12px;
    right: 12px;
    height: 20px;
    z-index: 3;
    border-radius: 100px;
    padding: 4px;
    background-color: #D3F9D8;
  }
  .avatar-icon {
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 100px;
    width: 32px;
    height: 32px;
    object-fit: cover;
  }
  .inbound-icon {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 13px;
    height: 13px;
  }
  .mins {
    position: relative;
    font-size: 13px;
    letter-spacing: 0.1px;
    line-height: 135%;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), var(--gray-60);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .lil-mouse-parent3 {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
    overflow: hidden;
  }
  .conversation-card5 {
    align-self: stretch;
    background-color: var(--background-layer-01);
    border-b: 1px solid var(--border-separator);
    box-sizing: border-box;
    height: 72px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 16px 12px;
    gap: 12px;
    font-size: 14px;
  }
  .olivia {
    font-weight: 500;
  }
  .what-do-you {
    color: var(--text-default);
  }
  .olivia-what-do-container {
    align-self: stretch;
    position: relative;
    font-size: 13px;
    letter-spacing: 0.1px;
    line-height: 135%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 18px;
    flex-shrink: 0;
  }
  .lil-mouse-parent4 {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
    font-size: 14px;
    color: var(--link-primary);
  }
  .lil-mouse15 {
    position: relative;
    font-size: 13px;
    letter-spacing: 0.1px;
    line-height: 135%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .lil-mouse-parent5 {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6px;
  }
  .summer-sale-event-container1 {
    align-self: stretch;
    position: relative;
    font-size: 13px;
    letter-spacing: 0.1px;
    line-height: 135%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 18px;
    flex-shrink: 0;
    color: var(--text-default);
  }
  .frame-parent {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
    font-size: 14px;
    color: var(--text-error);
  }
  .conversation-card-parent {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    font-size: 16px;
    color: var(--background-layer-01);
    font-family: var(--font-family-sans);
  }
</style>
<script>
    export default {
      props: {
        setConfiguration: {
          type: Object,
          required: false,
          default: null
        },
        setThreadId: {
          type: String,
          required: false,
          default: null
        },
      },
      created() {
        this.setActiveTab('All');
      },
      data: function () {
        return {
          active_tab: null,
          back_to_messages: 0,
          show_splash: true,
          send_message: ''
        }
      },
      computed: {
        page_type() {
          return this.setConfiguration?.PageType;
        },
      },
      methods: {
        setActiveTab(activeTab) {
          this.back_to_messages = Date.now();
          this.active_tab = activeTab;
        },
        sendMessage(message) {
          this.show_splash = false;
          this.send_message = message;
        }
      }
    }
</script>
